var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 668,
    height: 475,
    viewBox: "0 0 668 475",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.997 237.502V178.126L252.372 237.502L192.997 296.877V237.502Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.997 474.997V415.621L252.372 474.997H192.997Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.997 415.621L252.372 356.253L311.747 415.621H192.997Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.372 356.253L311.747 296.877L371.123 356.253H252.372Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.747 296.877L371.123 237.502L430.498 296.877H311.747Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.997 356.253V415.621L252.372 356.253H192.997Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.997 296.877L252.372 356.253L311.747 296.877H192.997Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.372 237.502L311.747 296.877L371.123 237.502H252.372Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.997 0V59.3754L252.372 0H192.997Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.997 59.3755L252.372 118.751L311.747 59.3755H192.997Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.372 118.751L311.747 178.126L371.123 118.751H252.372Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.747 178.126L371.123 237.502L430.498 178.126H311.747Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.997 118.751V59.3755L252.372 118.751H192.997Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.997 178.126L252.372 118.751L311.747 178.126H192.997Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.372 237.502L311.747 178.126L371.123 237.502H252.372Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.182 296.877L554.66 237.502H371.123L430.498 296.877",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.182 178.126L554.66 237.502H371.123L430.498 178.126",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.003 242.621L668 242.621V232.375L193.003 232.375V242.621Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.997 237.502V178.126L133.621 237.502L192.997 296.877V237.502Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.997 474.997V415.621L133.621 474.997H192.997Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.997 415.621L133.621 356.253L74.2526 415.621H192.997Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.621 356.253L74.2526 296.877L14.8772 356.253H133.621Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2526 296.877L14.8771 237.502L-44.4983 296.877H74.2526Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.997 356.253V415.621L133.621 356.253H192.997Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.997 296.877L133.621 356.253L74.2526 296.877H192.997Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.621 237.502L74.2526 296.877L14.8772 237.502H133.621Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.997 0V59.3754L133.621 0H192.997Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.997 59.3755L133.621 118.751L74.2526 59.3755H192.997Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.621 118.751L74.2526 178.126L14.8772 118.751H133.621Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2526 178.126L14.8771 237.502L-44.4983 178.126H74.2526Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.997 118.751V59.3755L133.621 118.751H192.997Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.997 178.126L133.621 118.751L74.2526 178.126H192.997Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.621 237.502L74.2526 178.126L14.8772 237.502H133.621Z",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-236.182 296.877L-168.659 237.502H14.8772L-44.4983 296.877",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-236.182 178.126L-168.659 237.502H14.8772L-44.4983 178.126",
    fill: "#FDF8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.997 232.375H-282V242.621H192.997V232.375Z",
    fill: "#FDF8ED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackImage);
export default __webpack_public_path__ + "static/media/backImage.8c128fd3b3cdb3ce6b54f73bb6a8b7dc.svg";
export { ForwardRef as ReactComponent };